<fa-icon [icon]="faSpinner" animation="spin"></fa-icon>